import cn from 'classnames'
import { useModal } from 'mmfintech-commons'
import React, { type ReactElement, useEffect } from 'react'
import { useLocation } from 'react-router-dom'

import styles from './Sidebar.module.scss'

type SidebarComponentProps = {
  content: ReactElement
  options: {
    closeIconPosition?: 'default'
    closeOnClickOutside?: boolean
    closeOnEscape?: boolean
    hideCloseIcon?: boolean
    scrollable?: boolean
    maxWidth?: number
    onClose?: () => void
    transparent?: boolean
    size?: 'auto' | 'small' | 'medium' | 'large' | 'extra-large' | 'horizontal' | 'centered'
  }
  visible: boolean
  onClose: () => void
}

const SidebarComponent = ({ content, visible, onClose, options }: SidebarComponentProps) => {
  const { ref, handleMouseDown } = useModal({
    options,
    visible,
    onClose
  })

  const location = useLocation()

  useEffect(() => {
    if (visible) {
      onClose?.()
    }
  }, [location.pathname])

  return (
    <div
      className={cn(styles['sidebar-wrapper'], 'sidebar-wrapper', {
        [styles['sidebar-visible']]: visible,
        [styles['sidebar-hidden']]: !visible
      })}
      onMouseDown={handleMouseDown}
      ref={ref}
    >
      <div
        data-test='modal-container'
        className={cn(styles['sidebar-container'], 'sidebar-container', visible ? 'visible' : 'hidden', {
          [styles['sidebar-container-visible']]: visible,
          [styles['sidebar-container-hidden']]: !visible,
          [styles['sidebar-container-autosize']]: options?.size === 'auto',
          [styles['sidebar-container-large']]: options?.size === 'large',
          [styles['sidebar-container-small']]: options?.size === 'small',
          [styles['sidebar-container-extra-large']]: options?.size === 'extra-large',
          [styles['sidebar-container-centered']]: options?.size === 'centered',
          [styles['sidebar-container-horizontal']]: options?.size === 'horizontal',
          [styles['sidebar-container-transparent']]: options?.transparent
        })}
        onMouseDown={(e: React.MouseEvent) => e.stopPropagation()}
      >
        {content}
      </div>
    </div>
  )
}

export const Sidebar = SidebarComponent
